<myarvato-title [darkMode]="false" [big]="true" [title]="'pages.transport.tracking-overview.title' | translate">
  <myarvato-fake-searchbar
    searchbar
    [placeholder]="'pages.transport.tracking-list.search-placeholder' | translate"
    (OnClick)="onSearchbarClick()"
  ></myarvato-fake-searchbar>
</myarvato-title>

<div class="container">
  <div class="row">
    <main class="col-12 col-md-7 col-lg-8 col-xl-9 d-flex flex-column gap--24 pb-4">
      <transport-key-indicators></transport-key-indicators>
      <!--      <transport-status-over-time></transport-status-over-time>-->
    </main>
    <aside class="col-12 col-md-5 col-lg-4 col-xl-3 d-flex flex-column gap--24 pb-4">
      <transport-news-update></transport-news-update>
      <transport-saved-views></transport-saved-views>
      <transport-watched-shipments></transport-watched-shipments>
    </aside>
  </div>
</div>

<ng-template #searchDialogRowTemplate let-item>
  <div>{{ item.trackingNumber }} • {{ item.shipToName1 }}, {{ item.shipToStreet }}, {{ item.shipToCity }}</div>
</ng-template>
